export default {

    // True when both route names share a common prefix containing 'Child',
    // i.e. we are moving between tabs of the same record. The router uses this
    // to avoid overwriting the list page it should return to.
    //
    // Either name can be absent - on the first navigation of a session `from`
    // has no name, and the detail parent routes are unnamed - which used to
    // throw here and skip recording the page to return to.
    matchStartingSubString(str1, str2) {
        if (!str1 || !str2) return false

        var i = 0
        while (i < str1.length && str1[i] === str2[i]) i++

        return (i> 5 && str1.substring(0, i).includes('Child')  && str2.substring(0, i).includes('Child'))
    }

}